/**
 * @generated SignedSource<<7a8cb48260401ca5cf66cc515489a204>>
 * @relayHash 37a30727c02a89778d50cca52d6a353d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 22cd6a69c38f8e0dcda92ad068c3a4b866566fb9f9342a5b669e9100b01612b9

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useRecentItemsRefetchableQuery$variables = {
  cloudId: string;
  count: number;
  keyword?: string | null;
};
export type useRecentItemsRefetchableQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useRecentItems">;
};
export type useRecentItemsRefetchableQuery = {
  response: useRecentItemsRefetchableQuery$data;
  variables: useRecentItemsRefetchableQuery$variables;
};
({
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled": isJpdRoadmapsRecentsEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisGsnBoardUrlFixEnabled": isGsnBoardUrlFixEnabled_provider
} as {
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisGsnBoardUrlFixEnabled: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled: {
    readonly get: () => boolean;
  };
});

import isGsnBoardUrlFixEnabled_provider from '@jira/platform__graphql-relay-provider/src/isGsnBoardUrlFixEnabled';
import isJpdRoadmapsRecentsEnabled_provider from '@jira/platform__graphql-relay-provider/src/isJpdRoadmapsRecentsEnabled';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "keyword"
},
v3 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "keyword",
        "variableName": "keyword"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  {
    "kind": "Literal",
    "name": "types",
    "value": [
      "PROJECT",
      "FILTER",
      "DASHBOARD",
      "BOARD",
      "QUEUE",
      "ISSUE",
      "PLAN",
      "JPD_COLLECTION"
    ]
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "lastViewedTimestamp"
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    (v5/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v8 = {
  "kind": "LinkedField",
  "name": "defaultNavigationItem",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "url"
        }
      ],
      "type": "JiraNavigationItem",
      "abstractKey": "__isJiraNavigationItem"
    },
    (v7/*: any*/)
  ]
},
v9 = [
  (v5/*: any*/),
  (v6/*: any*/),
  {
    "alias": "filterName",
    "kind": "ScalarField",
    "name": "name"
  },
  {
    "kind": "ScalarField",
    "name": "filterUrl"
  },
  {
    "kind": "ScalarField",
    "name": "filterId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useRecentItemsRefetchableQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          }
        ],
        "kind": "FragmentSpread",
        "name": "useRecentItems"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisGsnBoardUrlFixEnabled"
      }
    ],
    "kind": "Operation",
    "name": "useRecentItemsRefetchableQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "_recentItems",
            "args": (v3/*: any*/),
            "concreteType": "JiraSearchableEntityConnection",
            "kind": "LinkedField",
            "name": "recentItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraSearchableEntityEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/),
                          {
                            "concreteType": "JiraSingleLineTextField",
                            "kind": "LinkedField",
                            "name": "summaryField",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "text"
                              },
                              (v5/*: any*/)
                            ]
                          },
                          {
                            "alias": "issueWebUrl",
                            "kind": "ScalarField",
                            "name": "webUrl"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "issueId"
                          }
                        ],
                        "type": "JiraIssue"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/),
                          {
                            "alias": "title",
                            "kind": "ScalarField",
                            "name": "name"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "key"
                          },
                          (v8/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "description"
                          },
                          {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "large"
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "projectId"
                          }
                        ],
                        "type": "JiraProject"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "planId"
                          },
                          {
                            "concreteType": "JiraScenario",
                            "kind": "LinkedField",
                            "name": "scenario",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "scenarioId"
                              },
                              (v5/*: any*/)
                            ]
                          },
                          {
                            "alias": "planTitle",
                            "kind": "ScalarField",
                            "name": "title"
                          }
                        ],
                        "type": "JiraPlan"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "name"
                          },
                          {
                            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisGsnBoardUrlFixEnabled",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "boardUrl"
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "boardId"
                          },
                          {
                            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisGsnBoardUrlFixEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              (v8/*: any*/)
                            ]
                          }
                        ],
                        "type": "JiraBoard"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/),
                          {
                            "alias": "dashboardTitle",
                            "kind": "ScalarField",
                            "name": "title"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "dashboardUrl"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "dashboardId"
                          }
                        ],
                        "type": "JiraDashboard"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v9/*: any*/),
                        "type": "JiraSystemFilter"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v9/*: any*/),
                        "type": "JiraCustomFilter"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/),
                          {
                            "alias": "queueTitle",
                            "kind": "ScalarField",
                            "name": "title"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "queueUrl"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "queueId"
                          }
                        ],
                        "type": "JiraServiceManagementQueue"
                      },
                      {
                        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v5/*: any*/),
                              (v6/*: any*/),
                              {
                                "alias": "collectionTitle",
                                "kind": "ScalarField",
                                "name": "title"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "collectionUrl"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "collectionId"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "emoji"
                              }
                            ],
                            "type": "JiraProductDiscoveryCollection"
                          }
                        ]
                      },
                      (v7/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  }
                ]
              }
            ]
          },
          {
            "alias": "_recentItems",
            "args": (v3/*: any*/),
            "filters": [
              "cloudId",
              "types",
              "filter"
            ],
            "handle": "connection",
            "key": "useRecentItemsPaged__recentItems",
            "kind": "LinkedHandle",
            "name": "recentItems"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "22cd6a69c38f8e0dcda92ad068c3a4b866566fb9f9342a5b669e9100b01612b9",
    "metadata": {},
    "name": "useRecentItemsRefetchableQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled": isJpdRoadmapsRecentsEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisGsnBoardUrlFixEnabled": isGsnBoardUrlFixEnabled_provider
    }
  }
};
})();

(node as any).hash = "c7427eba8c734344b51198ca307b6328";

export default node;
